import React from 'react';
import { Grid } from '@material-ui/core';
import { Typography } from '@kareo/design-system';
import { FacesheetCardList } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import HistorySectionHeader from 'shared-assets/facesheet-ui/components/Facesheet/History/HistorySectionHeader';
import { HistorySectionTitle, } from 'shared-assets/facesheet-ui/service/facesheet/types';
var OBPregnancySection = function (_a) {
    var obPregnancyHistory = _a.obPregnancyHistory, historyComments = _a.historyComments, obHistoryText = _a.obHistoryText, pregnancyHistoryText = _a.pregnancyHistoryText;
    return (React.createElement(Grid, { item: true },
        React.createElement(HistorySectionHeader, { title: HistorySectionTitle.OB_PREGNANCY }),
        React.createElement(FacesheetCardList, null,
            React.createElement(Typography, { variant: "body1", component: "div" },
                (obPregnancyHistory.mensesAge > 0 ||
                    obPregnancyHistory.menopauseAge > 0) && (React.createElement("li", { key: 0 },
                    "OB History: ",
                    obHistoryText)),
                historyComments.obHistory && (React.createElement("li", { key: 1 },
                    "OB Comments: ",
                    historyComments.obHistory)),
                obPregnancyHistory.numberOfPregnancy > 0 && (React.createElement("li", { key: 2 },
                    "Pregnancy History: ",
                    pregnancyHistoryText)),
                historyComments.pregnancyHistory && (React.createElement("li", { key: 3 },
                    "Pregnancy Comments: ",
                    historyComments.pregnancyHistory))))));
};
export default OBPregnancySection;
